export default "__VITE_ASSET__evRhMj8D__"